import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index' //首页页面
import home from '@/components/views/home' // 封面内容

import join from '@/components/views/join' // 加盟
import service from '@/components/views/service' // 服务
import concatsus from '@/components/views/concatsus' // 联系我们

// 产品类
import goodsType from '@/components/views/goods/goodsType' // 产品分类页面
import goods from '@/components/views/goods/goods' // 产品列表页（需携带typeID）
import goodsDesc from '@/components/views/goods/goodsDesc' // 产品详情页（需携带goodsID）

// 公司简介类
import comp_index from '@/components/views/comp/comp_index' // 公司简介
import comp_ry from '@/components/views/comp/comp_ry' // 公司荣誉
import comp_qs from '@/components/views/comp/comp_qs' // 品牌诠释

// 公司成功案例
import caseIndex from '@/components/views/compCase/caseIndex' // 成功案例
import caseIList from '@/components/views/compCase/caseList' // 成功案例

// 新闻类
import news from '@/components/views/news/news' // 新闻
import newsInfo from '@/components/views/news/newsInfo' // 新闻详情

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'parent',
      component: Index,
      children:[
        {
          path: '',
          name:"home",
          component: home,
          meta: {
            title: '【VANTIS梵蒂斯官方网】西安梵蒂斯-梵蒂斯门业官方网站',
            keywords: '西安梵蒂斯,VANTIS梵蒂斯,VANTIS梵蒂斯官网,梵蒂斯官网,梵蒂斯装甲门,梵蒂斯装甲门官网,梵蒂斯官方网站',
            description: '梵蒂斯-为居者打造梦想之门;中国装甲门系统标准主起草单位,奠基中国好门新未来;行业内首家通过德国PHI体系认证装甲门企业;国家智能制造大规模个性化定制优秀场景.VANTIS梵蒂斯门业-梵蒂斯秉承文森特•威廉•梵高的艺术思想和创作理念,目前拥有五大产品系列:锻铜门,铸铝门,装甲门,铸铝艺术门,铸铝庭院门.'
          }
        },
        {
          path: '/goodsType',
          name: 'goodsType',
          component: goodsType,
          meta: {
            title: '【VANTIS梵蒂斯官方网】西安梵蒂斯-产品分类',
            keywords: '西安梵蒂斯,VANTIS梵蒂斯,VANTIS梵蒂斯官网,梵蒂斯官网,梵蒂斯装甲门,梵蒂斯装甲门官网,梵蒂斯官方网站',
            description: '梵蒂斯-为居者打造梦想之门;中国装甲门系统标准主起草单位,奠基中国好门新未来;行业内首家通过德国PHI体系认证装甲门企业;国家智能制造大规模个性化定制优秀场景.VANTIS梵蒂斯门业-梵蒂斯秉承文森特•威廉•梵高的艺术思想和创作理念,目前拥有五大产品系列:锻铜门,铸铝门,装甲门,铸铝艺术门,铸铝庭院门.'
          }
        },
        {
          path: '/goods',
          name: 'goods',
          component: goods,
          meta: {
            title: '【VANTIS梵蒂斯官方网】西安梵蒂斯-产品列表',
            keywords: '西安梵蒂斯,VANTIS梵蒂斯,VANTIS梵蒂斯官网,梵蒂斯官网,梵蒂斯装甲门,梵蒂斯装甲门官网,梵蒂斯官方网站',
            description: '梵蒂斯-为居者打造梦想之门;中国装甲门系统标准主起草单位,奠基中国好门新未来;行业内首家通过德国PHI体系认证装甲门企业;国家智能制造大规模个性化定制优秀场景.VANTIS梵蒂斯门业-梵蒂斯秉承文森特•威廉•梵高的艺术思想和创作理念,目前拥有五大产品系列:锻铜门,铸铝门,装甲门,铸铝艺术门,铸铝庭院门.'
          }
        },
        {
          path: '/goodsDesc',
          name: 'goodsDesc',
          component: goodsDesc,
          meta: {
            title: '【VANTIS梵蒂斯官方网】西安梵蒂斯-产品明细',
            keywords: '西安梵蒂斯,VANTIS梵蒂斯,VANTIS梵蒂斯官网,梵蒂斯官网,梵蒂斯装甲门,梵蒂斯装甲门官网,梵蒂斯官方网站',
            description: '梵蒂斯-为居者打造梦想之门;中国装甲门系统标准主起草单位,奠基中国好门新未来;行业内首家通过德国PHI体系认证装甲门企业;国家智能制造大规模个性化定制优秀场景.VANTIS梵蒂斯门业-梵蒂斯秉承文森特•威廉•梵高的艺术思想和创作理念,目前拥有五大产品系列:锻铜门,铸铝门,装甲门,铸铝艺术门,铸铝庭院门.'
          }
        },
        {
          path: '/comp_index',
          name: 'comp_index',
          component: comp_index,
          meta: {
            title: '【VANTIS梵蒂斯官方网】西安梵蒂斯-公司信息',
            keywords: '西安梵蒂斯,VANTIS梵蒂斯,VANTIS梵蒂斯官网,梵蒂斯官网,梵蒂斯装甲门,梵蒂斯装甲门官网,梵蒂斯官方网站',
            description: '梵蒂斯-为居者打造梦想之门;中国装甲门系统标准主起草单位,奠基中国好门新未来;行业内首家通过德国PHI体系认证装甲门企业;国家智能制造大规模个性化定制优秀场景.VANTIS梵蒂斯门业-梵蒂斯秉承文森特•威廉•梵高的艺术思想和创作理念,目前拥有五大产品系列:锻铜门,铸铝门,装甲门,铸铝艺术门,铸铝庭院门.'
          }
        },
        {
          path: '/comp_ry',
          name: 'comp_ry',
          component: comp_ry,
          meta: {
            title: '【VANTIS梵蒂斯官方网】西安梵蒂斯-公司荣誉',
            keywords: '西安梵蒂斯,VANTIS梵蒂斯,VANTIS梵蒂斯官网,梵蒂斯官网,梵蒂斯装甲门,梵蒂斯装甲门官网,梵蒂斯官方网站',
            description: '梵蒂斯-为居者打造梦想之门;中国装甲门系统标准主起草单位,奠基中国好门新未来;行业内首家通过德国PHI体系认证装甲门企业;国家智能制造大规模个性化定制优秀场景.VANTIS梵蒂斯门业-梵蒂斯秉承文森特•威廉•梵高的艺术思想和创作理念,目前拥有五大产品系列:锻铜门,铸铝门,装甲门,铸铝艺术门,铸铝庭院门.'
          }
        },
        {
          path: '/comp_qs',
          name: 'comp_qs',
          component: comp_qs,
          meta: {
            title: '【VANTIS梵蒂斯官方网】西安梵蒂斯-企业诠释',
            keywords: '西安梵蒂斯,VANTIS梵蒂斯,VANTIS梵蒂斯官网,梵蒂斯官网,梵蒂斯装甲门,梵蒂斯装甲门官网,梵蒂斯官方网站',
            description: '梵蒂斯-为居者打造梦想之门;中国装甲门系统标准主起草单位,奠基中国好门新未来;行业内首家通过德国PHI体系认证装甲门企业;国家智能制造大规模个性化定制优秀场景.VANTIS梵蒂斯门业-梵蒂斯秉承文森特•威廉•梵高的艺术思想和创作理念,目前拥有五大产品系列:锻铜门,铸铝门,装甲门,铸铝艺术门,铸铝庭院门.'
          }
        },
        {
          path: '/caseIndex',
          name: 'caseIndex',
          component: caseIndex,
          meta: {
            title: '【VANTIS梵蒂斯官方网】西安梵蒂斯-成功案例',
            keywords: '西安梵蒂斯,VANTIS梵蒂斯,VANTIS梵蒂斯官网,梵蒂斯官网,梵蒂斯装甲门,梵蒂斯装甲门官网,梵蒂斯官方网站',
            description: '梵蒂斯-为居者打造梦想之门;中国装甲门系统标准主起草单位,奠基中国好门新未来;行业内首家通过德国PHI体系认证装甲门企业;国家智能制造大规模个性化定制优秀场景.VANTIS梵蒂斯门业-梵蒂斯秉承文森特•威廉•梵高的艺术思想和创作理念,目前拥有五大产品系列:锻铜门,铸铝门,装甲门,铸铝艺术门,铸铝庭院门.'
          }
        },
        {
          path: '/caseIList',
          name: 'caseIList',
          component: caseIList,
          meta: {
            title: '【VANTIS梵蒂斯官方网】西安梵蒂斯-案例列表',
            keywords: '西安梵蒂斯,VANTIS梵蒂斯,VANTIS梵蒂斯官网,梵蒂斯官网,梵蒂斯装甲门,梵蒂斯装甲门官网,梵蒂斯官方网站',
            description: '梵蒂斯-为居者打造梦想之门;中国装甲门系统标准主起草单位,奠基中国好门新未来;行业内首家通过德国PHI体系认证装甲门企业;国家智能制造大规模个性化定制优秀场景.VANTIS梵蒂斯门业-梵蒂斯秉承文森特•威廉•梵高的艺术思想和创作理念,目前拥有五大产品系列:锻铜门,铸铝门,装甲门,铸铝艺术门,铸铝庭院门.'
          }
        },
        {
          path: '/news',
          name: 'news',
          component: news,
          meta: {
            title: '【VANTIS梵蒂斯官方网】西安梵蒂斯-公司新闻',
            keywords: '西安梵蒂斯,VANTIS梵蒂斯,VANTIS梵蒂斯官网,梵蒂斯官网,梵蒂斯装甲门,梵蒂斯装甲门官网,梵蒂斯官方网站',
            description: '梵蒂斯-为居者打造梦想之门;中国装甲门系统标准主起草单位,奠基中国好门新未来;行业内首家通过德国PHI体系认证装甲门企业;国家智能制造大规模个性化定制优秀场景.VANTIS梵蒂斯门业-梵蒂斯秉承文森特•威廉•梵高的艺术思想和创作理念,目前拥有五大产品系列:锻铜门,铸铝门,装甲门,铸铝艺术门,铸铝庭院门.'
          }
        },
        {
          path: '/newsInfo',
          name: 'newsInfo',
          component: newsInfo,
          meta: {
            title: '【VANTIS梵蒂斯官方网】西安梵蒂斯-新闻明细',
            keywords: '西安梵蒂斯,VANTIS梵蒂斯,VANTIS梵蒂斯官网,梵蒂斯官网,梵蒂斯装甲门,梵蒂斯装甲门官网,梵蒂斯官方网站',
            description: '梵蒂斯-为居者打造梦想之门;中国装甲门系统标准主起草单位,奠基中国好门新未来;行业内首家通过德国PHI体系认证装甲门企业;国家智能制造大规模个性化定制优秀场景.VANTIS梵蒂斯门业-梵蒂斯秉承文森特•威廉•梵高的艺术思想和创作理念,目前拥有五大产品系列:锻铜门,铸铝门,装甲门,铸铝艺术门,铸铝庭院门.'
          }
        },
        {
          path: '/join',
          name: 'join',
          component: join,
          meta: {
            title: '【VANTIS梵蒂斯官方网】西安梵蒂斯-加盟合作',
            keywords: '西安梵蒂斯,VANTIS梵蒂斯,VANTIS梵蒂斯官网,梵蒂斯官网,梵蒂斯装甲门,梵蒂斯装甲门官网,梵蒂斯官方网站',
            description: '梵蒂斯-为居者打造梦想之门;中国装甲门系统标准主起草单位,奠基中国好门新未来;行业内首家通过德国PHI体系认证装甲门企业;国家智能制造大规模个性化定制优秀场景.VANTIS梵蒂斯门业-梵蒂斯秉承文森特•威廉•梵高的艺术思想和创作理念,目前拥有五大产品系列:锻铜门,铸铝门,装甲门,铸铝艺术门,铸铝庭院门.'
          }
        },
        {
          path: '/service',
          name: 'service',
          component: service,
          meta: {
            title: '【VANTIS梵蒂斯官方网】西安梵蒂斯-服务保障',
            keywords: '西安梵蒂斯,VANTIS梵蒂斯,VANTIS梵蒂斯官网,梵蒂斯官网,梵蒂斯装甲门,梵蒂斯装甲门官网,梵蒂斯官方网站',
            description: '梵蒂斯-为居者打造梦想之门;中国装甲门系统标准主起草单位,奠基中国好门新未来;行业内首家通过德国PHI体系认证装甲门企业;国家智能制造大规模个性化定制优秀场景.VANTIS梵蒂斯门业-梵蒂斯秉承文森特•威廉•梵高的艺术思想和创作理念,目前拥有五大产品系列:锻铜门,铸铝门,装甲门,铸铝艺术门,铸铝庭院门.'
          }
        },
        {
          path: '/concatsus',
          name: 'concatsus',
          component: concatsus,
          meta: {
            title: '【VANTIS梵蒂斯官方网】西安梵蒂斯-联系我们',
            keywords: '西安梵蒂斯,VANTIS梵蒂斯,VANTIS梵蒂斯官网,梵蒂斯官网,梵蒂斯装甲门,梵蒂斯装甲门官网,梵蒂斯官方网站',
            description: '梵蒂斯-为居者打造梦想之门;中国装甲门系统标准主起草单位,奠基中国好门新未来;行业内首家通过德国PHI体系认证装甲门企业;国家智能制造大规模个性化定制优秀场景.VANTIS梵蒂斯门业-梵蒂斯秉承文森特•威廉•梵高的艺术思想和创作理念,目前拥有五大产品系列:锻铜门,铸铝门,装甲门,铸铝艺术门,铸铝庭院门.'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js